/**
 * Auto-generated from apps/python-api/models/assistant_tools.py.
 * DO NOT EDIT - regenerate from apps/python-api:
 *   python -m scripts.export_assistant_contracts
 */

export const ASSISTANT_TOOL_NAMES = [
  "document_search",
  "web_search",
  "read_skill",
  "read_workflow",
  "read_audience",
  "read_results",
  "read_artifact",
  "update_artifact",
  "run_workflow",
  "analyze_audience",
  "create_artifact",
  "delete_artifact",
  "analyze_results",
  "revise_run_step",
  "propose_social_tracker",
  "read_room",
  "read_study",
  "ask_study",
  "read_document",
  "read_tracker_posts",
  "analyze_table",
  "research_search",
  "analyze_tracker_posts",
  "generate_image",
  "write_report",
  "prepare_study",
  "search_connected_sources",
  "call_connected_source",
  "list_datasets",
  "prepare_quick_study",
  "read_social_topic",
  "analyze_social_topic",
  "search_social_posts",
  "read_social_post",
  "prepare_conversation",
] as const;

export type AssistantToolName = (typeof ASSISTANT_TOOL_NAMES)[number];

export const ASSISTANT_STAGE_NAMES = [
  "report_reading",
  "report_writing",
  "report_checking",
] as const;

export type AssistantStageName = (typeof ASSISTANT_STAGE_NAMES)[number];

export const ASSISTANT_STREAM_EVENT_TYPES = [
  "delta",
  "tool_start",
  "tool_end",
  "citations",
  "judgment",
  "suggestions",
  "done",
  "error",
  "citations_v2",
  "library_outcome",
  "web_outcome",
  "image_progress",
] as const;

export type AssistantStreamEventType = (typeof ASSISTANT_STREAM_EVENT_TYPES)[number];

export const ASSISTANT_ACTIVITY_SOURCE_KINDS = ["library", "social", "study", "room", "audience", "web", "dataset", "connector_record"] as const;

export const ASSISTANT_ACTIVITY_COUNT_UNITS = ["study", "conversation", "document", "social_digest", "post", "web_page", "related_audience", "dataset", "connector_record"] as const;

export const ASSISTANT_ACTIVITY_SUBJECT_KINDS = ["library", "social", "study", "room", "audience", "run", "dataset", "connector_record", "workflow", "report"] as const;

export const ASSISTANT_ACTIVITY_STUDY_GOALS = ["lp_conversion", "ad_creative", "concept_validation", "claim_validation", "brand_perception", "pricing_packaging", "pain_ranking", "explore"] as const;
